module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"companies":"Companies","users":"Users","studies":"Studies","company_groups":"Company groups"},"fr":{"companies":"Sociétés","users":"Utilisateurs","studies":"Etudes","company_groups":"Groupes de sociétés"},"de":{"companies":"Firmen","users":"Benutzer","studies":"Studien","company_groups":"Unternehmensgruppen"}}')
  delete Component.options._Ctor
}
